import classNames from 'classnames';
import { IconPlay } from '@/features/icons';
import usePDPData from '@/app/(pdp)/_utils/use-pdp-data';
import { useVariantContextValues } from '@/app/(pdp)/context/use-variant-context-values';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import { handleImageError } from '@/utils/image-error';
import { generateImageAlt } from '../utils/generate-image-alt';
import { useGallaryItems } from '../utils/use-gallary-items';
interface Props {
  activeIndex: number;
  onActiveIndexChange?: (index: number) => void;
  numberOfVisibleItems?: number;
}
const DesktopGalleryNavigation = ({
  onActiveIndexChange,
  activeIndex
}: Props) => {
  const {
    data
  } = usePDPData();
  const {
    activeVariant
  } = useVariantContextValues('pdp');
  const {
    thumbnails
  } = useGallaryItems('pdp');
  const totalCount = thumbnails.length;
  if (!thumbnails.length) return <div className='h-full w-11' />;
  const onSlideChange = (index: number) => onActiveIndexChange && onActiveIndexChange(index);
  return <div className='hidden h-full gap-4 lg:flex' data-sentry-component="DesktopGalleryNavigation" data-sentry-source-file="desktop-navigation.tsx">
            <div className='hide-scrollbar flex h-full max-h-[312px] w-11 flex-col items-center overflow-scroll'>
                <div className='flex flex-col items-center justify-start space-y-4 pt-1'>
                    {thumbnails.map(({
          id,
          imageUrl,
          isVideo
        }, index) => {
          const isSelected = activeIndex === index;
          const imageSize = isSelected ? 38 : 40;
          return <button key={id} type='button' onClick={() => onSlideChange(index)} className={classNames(isSelected ? 'border-surface-solid-0 outline outline-2 outline-text-black' : 'border-transparent', 'flex items-center justify-center overflow-hidden rounded border')}>
                                <div className={classNames('relative', {
              'bg-surface-scrim-black': isVideo
            })}>
                                    <img alt={generateImageAlt(index, data, activeVariant || undefined)} src={`${imageUrl}?w=34` || ''} className={classNames('aspect-square max-w-none rounded', isSelected ? 'h-9.5 w-9.5' : 'h-10 w-10')} onError={handleImageError} loading={index > 5 && !PUBLIC_IS_BOT ? 'lazy' : undefined} width={imageSize} height={imageSize} />

                                    {isVideo && <IconPlay className='absolute right-1/2 top-1/2 h-6 w-6 -translate-y-1/2 translate-x-1/2 text-text-white' />}
                                </div>
                            </button>;
        })}
                </div>

                {totalCount > 5 && <div className='w-fit'>
                        <div className='mt-1 border-b border-gray-200' />
                    </div>}
            </div>
        </div>;
};
export default DesktopGalleryNavigation;